import { Inline, Tag, BoxedRow, Text1, skinVars } from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../utils/navigation/navigateParams';
import './index.scss';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';
import { useDispatch } from 'react-redux';
import { showStopper } from '../../utils/store/features/user';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import { createUseStyles } from 'react-jss';
import RigthIconsConvergent from '../RigthIconsConvergent';
import ExtraMobileConvergent from '../ExtraMobileConvergent';
import { useConfigureLineContext } from '../../context/configure-line-context/ConfigureLineContext';

const useCardGroupStyles = createUseStyles({
    group: {
        '& > *': {
            maxWidth: 298,
            minWidth: 284,
        },
    },
});
export interface MobileSectionsData {
    dataMobiles: any;
    sharedData: any;
}

const MobileSections: React.FC<MobileSectionsData> = ({ dataMobiles }: MobileSectionsData) => {
    const { t } = useTranslation();
    const classes = useCardGroupStyles();
    const { blockedLines } = useConfigureLineContext();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const consumptionsDisabled = managementEnvironment().VITE_STOPPER_CONSUMPTIONS_DISABLED;
    const [dataBonusActive, setDataBonusActive] = useState<boolean>(false);
    const numberMainMobile = dataMobiles.dataTab.mainMobile.number || '';
    const additionalMobiles: boolean = dataMobiles.dataTab.additionalMobiles.length !== 0;
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const role = () => {
        if (dataMobiles.dataTab.mainMobile.dataBonus !== undefined) {
            setDataBonusActive(true);
        }
        dataMobiles.dataTab.additionalMobiles.map((item: any, index: number) => {
            if (item.dataBonus !== undefined) {
                setDataBonusActive(true);
            }
        });
    };

    useEffect(() => {
        role();
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const sendToNativeMain = (event: any) => {
        event.preventDefault();
        if (consumptionsDisabled) {
            dispatch(showStopper());
        } else {
            const type = 'modeFlow-backgroundBlue';
            const title = 'Línea principal';
            const url = '/mobile';
            dataMobiles.dataTab.mainMobile.sharedData = dataMobiles.sharedData;
            navigate(url + '?productPsId=' + dataMobiles.dataTab.mainMobile.productPsId, { state: title });
            sessionStorage.setItem(
                'breadcrumb',
                JSON.stringify([
                    { title: 'Inicio', url: '/home' },
                    { title, url: url + '?productPsId=' + dataMobiles.dataTab.mainMobile.productPsId },
                ]),
            );
        }
    };

    const sendToNativeAdded = (event: any) => {
        event.preventDefault();
        if (consumptionsDisabled) {
            dispatch(showStopper());
        } else {
            const index = event.currentTarget.dataset.index;
            const type = 'modeFlow-backgroundBlue';
            const url = '/mobile';
            const title = 'Línea adicional';
            const queryParams = {
                productPsId: dataMobiles.dataTab.additionalMobiles[index].productPsId,
            };
            dataMobiles.dataTab.additionalMobiles[index].sharedData = dataMobiles.sharedData;
            if (navigateParams(type, url, queryParams, dataMobiles.dataTab.additionalMobiles[index], title)) {
                navigate(url + '?productPsId=' + dataMobiles.dataTab.additionalMobiles[index].productPsId, {
                    state: title,
                });
                sessionStorage.setItem(
                    'breadcrumb',
                    JSON.stringify([
                        { title: 'Inicio', url: '/home' },
                        { title, url: url + '?productPsId=' + dataMobiles.dataTab.mainMobile.productPsId },
                    ]),
                );
            }
        }
    };

    return (
        <div className='mobile-sections'>
            <div className='mobile-sections__title'>
                <Text1 medium color={skinVars.colors.textSecondary}>
                    {t('mobileLines')}
                </Text1>
            </div>
            <div className='mobile-sections__cards'>
                {additionalMobiles ? (
                    <Inline
                        space={windowWidth >= 1220 ? 24 : 16}
                        className={classes.group}
                        wrap={windowWidth >= 1024 ? true : false}
                    >
                        <div onClick={sendToNativeMain} className='mobile-sections__cards-consumption'>
                            <BoxedRow
                                headline={<Tag type='active'>{t('breadcrumbsPrincipalLine')}</Tag>}
                                title={formatMobileNumber(numberMainMobile)}
                                right={
                                    <div>
                                        <RigthIconsConvergent
                                            isBadge={dataMobiles.dataTab.mainMobile.extraSum > 0}
                                            dataSharing={dataMobiles.dataTab.datasharing}
                                            isBonus={dataMobiles.dataTab.mainMobile.dataBonus ? true : false}
                                            isCloud={dataMobiles.dataTab.mainMobile.cloudHired}
                                            isBlocked={blockedLines.includes(dataMobiles.dataTab.mainMobile.productId)}
                                        />
                                    </div>
                                }
                                extra={
                                    <div
                                        className='mobile-sections__extra'
                                        style={{ marginRight: '8px', marginTop: '4px' }}
                                    >
                                        <ExtraMobileConvergent
                                            isBonus={dataMobiles.dataTab.mainMobile.dataBonus ? true : false}
                                            data={
                                                dataMobiles.dataTab.datasharing
                                                    ? dataMobiles.dataTab.mainMobile.dataSharing
                                                        ? dataMobiles.dataTab.mainMobile.dataSharing
                                                        : dataMobiles.dataTab.mainMobile.data
                                                    : dataMobiles.dataTab.mainMobile.dataBonus
                                                      ? dataMobiles.dataTab.mainMobile.dataBonus
                                                      : dataMobiles.dataTab.mainMobile.data
                                            }
                                            isBadge={dataMobiles.dataTab.mainMobile.extraSum > 0}
                                            dataSharing={dataMobiles.dataTab.datasharing}
                                            isBlocked={blockedLines.includes(dataMobiles.dataTab.mainMobile.productId)}
                                        />
                                    </div>
                                }
                            />
                        </div>
                        {(dataMobiles.dataTab.additionalMobiles || []).map((item: any, index: number) => {
                            return (
                                <div
                                    key={index}
                                    data-index={index}
                                    onClick={sendToNativeAdded}
                                    className='mobile-sections__cards-consumption'
                                    style={{ flex: windowWidth >= 1024 ? '1 0 50%' : 'none' }}
                                >
                                    <BoxedRow
                                        role={dataBonusActive && windowWidth >= 1024 ? 'cardConsumption' : ''}
                                        headline={<Tag type='active'>{t('additionalLine')}</Tag>}
                                        title={formatMobileNumber(item.number)}
                                        extra={
                                            <ExtraMobileConvergent
                                                isBonus={dataMobiles.dataTab.mainMobile.dataBonus ? true : false}
                                                data={
                                                    item.datasharing
                                                        ? item.dataSharing
                                                            ? item.dataSharing
                                                            : item.data
                                                        : item.dataBonus
                                                          ? item.dataBonus
                                                          : item.data
                                                }
                                                isBadge={item.extraSum > 0}
                                                dataSharing={item.datasharing}
                                                isBlocked={blockedLines.includes(item.productId)}
                                            />
                                        }
                                        right={
                                            <div>
                                                <RigthIconsConvergent
                                                    isBadge={item.extraSum > 0}
                                                    dataSharing={item.datasharing}
                                                    isBonus={item.dataBonus ? true : false}
                                                    isCloud={item.cloudHired}
                                                    isBlocked={blockedLines.includes(item.productId)}
                                                />
                                            </div>
                                        }
                                    />
                                </div>
                            );
                        })}
                    </Inline>
                ) : (
                    <div className='mobile-sections__cards__onlyMainMobile'>
                        <div onClick={sendToNativeMain}>
                            <BoxedRow
                                headline={<Tag type='active'>{t('breadcrumbsPrincipalLine')}</Tag>}
                                title={formatMobileNumber(numberMainMobile)}
                                right={
                                    <div>
                                        <RigthIconsConvergent
                                            isBadge={dataMobiles.dataTab.mainMobile.extraSum > 0}
                                            dataSharing={dataMobiles.dataTab.datasharing}
                                            isBonus={dataMobiles.dataTab.mainMobile.dataBonus ? true : false}
                                            isCloud={dataMobiles.dataTab.mainMobile.cloudHired}
                                            isBlocked={blockedLines.includes(dataMobiles.dataTab.mainMobile.productId)}
                                        />
                                    </div>
                                }
                                extra={
                                    <div
                                        className='mobile-sections__extra'
                                        style={{ marginRight: '8px', marginTop: '4px' }}
                                    >
                                        <ExtraMobileConvergent
                                            isBonus={dataMobiles.dataTab.mainMobile.dataBonus ? true : false}
                                            data={
                                                dataMobiles.dataTab.datasharing
                                                    ? dataMobiles.dataTab.mainMobile.dataSharing
                                                    : dataMobiles.dataTab.mainMobile.dataBonus
                                                      ? dataMobiles.dataTab.mainMobile.dataBonus
                                                      : dataMobiles.dataTab.mainMobile.data
                                            }
                                            isBadge={dataMobiles.dataTab.mainMobile.extraSum > 0}
                                            dataSharing={dataMobiles.dataTab.datasharing}
                                            isBlocked={blockedLines.includes(dataMobiles.dataTab.mainMobile.productId)}
                                        />
                                    </div>
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MobileSections;
